<template>
    <div class="modal fade" :class="{ in: isShowModal, active: isShow}" role="dialog" id="moreSailDatePopup">
        <div class="modal-bg" @click="onMoreSailDateClose"></div>

        <div class="common-modal-dialog modal-dialog" style="width: 922px;top: 50px;overflow: initial;">
            <div class="modal-content">
                <div class="modal-body">
                    <img class="common-modal-close" style="width: 23px;" src="https://resource.rcclchina.com.cn/tui2/list/modal-close.png"
                    @click="onMoreSailDateClose" />
                    <div class="list-more-date-con">
                        <div class="list-more-date-left-con">
                            <div class="calendar">
                                <div class="calendar__title" ref="calendarTitle ">
                                    <div class="calendar__title_content" ref="titleContent">
                                        <div class="calendar__title_wrapper">
                                                <div v-for="(month, i) in totalMonth" :key="i" ref="calendarTitleText"
                                                :class="{ active: isTitleActive(month)}"
                                                @click="onMonthClick(month)"
                                                class="title title__text">{{month}}</div>
                                        </div>
                                    </div>
                                    <i class="sPrev title-change-icon sail-date-arrow sail-date-arrow-left" data-type="pre" aria-hidden="true" @click="goPreMonth"></i>
                                    <i class="sNext title-change-icon sail-date-arrow sail-date-arrow-right" data-type="next" aria-hidden="true" @click="goNextMonth"></i>
                                </div>
                                <div class="calendar--header">
                                    <div class="calendar--header__weekday calendar--cell vacation">日</div>
                                    <div class="calendar--header__weekday calendar--cell">一</div>
                                    <div class="calendar--header__weekday calendar--cell">二</div>
                                    <div class="calendar--header__weekday calendar--cell">三</div>
                                    <div class="calendar--header__weekday calendar--cell">四</div>
                                    <div class="calendar--header__weekday calendar--cell">五</div>
                                    <div class="calendar--header__weekday calendar--cell vacation">六</div>

                                </div>
                                <div class="calendar--body">
                                    <div v-for="(week, i) in getMonthCalendar()" :key="i" class="calendar--body__line">
                                        <div v-for="(day, j) in week" :key="j" class="line day calendar--cell"
                                        @click="onCalendarItemClick(day)"
                                        :class="{ active: day.code == selectedCruise.date, shipEvent: hasCalendarEvent(day.code)}">
                                            <div v-if="day.name > 0" :class="{ 'cell-active': day.name > 0 && day.price && day.price.length > 0}">
                                                <div class="dateCell">
                                                    <div class="bg"></div>
                                                    <span class="date">{{day.name}}</span>
                                                </div>
                                            </div>
                                            <div v-if="day.name > 0 && day.price && day.price.length > 0" class="priceCell priceCellHp">
                                                <div>
                                                    <span class="small-font">￥</span>
                                                    <span class="price">{{day.price}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="list-more-date-right-con" id="moreSailDatePopupCruiseInfo"
                            v-if="selectedCruise && selectedCruise.cruise">
                            <div class="list-item-con" style="width: 92%;">
                                <div class="item-title-con">
                                    <div class="item-title float-left " style="width: 300px;">{{selectedCruise.cruise.routeCode}}</div>
                                    <div class="like-con"
                                        :class="{ active: selectedCruise.cruise.inWish}"
                                        @click="onWishListClick(selectedCruise.cruise)">
                                        <img class="moreLikeDef" src="https://resource.rcclchina.com.cn/TUI2PCImg/SearchPackage/like-def.jpg">
                                        <img class="moreLike" src="https://resource.rcclchina.com.cn/tui2/list/like-checked.png">
                                        <div class="moreCollections" style="line-height: 12px;">{{selectedCruise.cruise.collections}}</div>
                                    </div>
                                </div>
                                <div class="item-tag-con">
                                    <div class="item-tag-item choosenSupport" v-show="selectedCruise.cruise.choosenSupport">
                                        <img class="float-left" style="margin-right: 5px" src="https://resource.rcclchina.com.cn/tui2/list/icon-hot.png">
                                        <div class="float-left" style="color: #ff3022">爆款</div>
                                    </div>
                                </div>
                                <div class="item-info-text">
                                    <span class="moreSailDays">{{selectedCruise.cruise.sailDays}}天{{selectedCruise.cruise.sailDays-1}}晚</span>
                                    <span class="moreShipName" style="display: inline-block; margin-left: 18px;">{{selectedCruise.cruise.shipName}}</span>
                                </div>
                                <div class="item-info-text">
                                    <div class="float-left moreSailDateStr">{{selectedCruise.cruise.sailDateBegin}} - {{selectedCruise.cruise.sailDateEnd}}</div>
                                </div>
                                <div style="overflow: hidden;">
                                    <div class="list-search-input-tag-con" style="width: 100%;"
                                        v-if="selectedCruise.cruise.tags && selectedCruise.cruise.tags.length > 0">
                                        <CruiseTag
                                            v-for="(tag, i) in selectedCruise.cruise.tags" :key="('selectCruiseTag_' + i)"
                                            :tag="tag"
                                            :index="new Date().getTime() + '_moreSailDateTag_' + i"
                                        />
                                    </div>
                                    <div style="width:196px;"></div>
                                </div>
                                <div class="item-btn-con" @click="goToCruiseDetail(selectedCruise.cruise)">
                                    <div class="item-price moreCruiseOnly only" >
                                        <span class="cruise-only-title">{{getNrpTitle(selectedCruise.cruise.isNrpPrice)}}(含税)</span>
                                        <span style="color: #ffa70d;font-weight: bold;">￥</span>
                                        <span class="morePrice" style="color: #ffa70d; font-size: 28px; font-weight: bold;">{{selectedCruise.cruise.netAmount}}</span>
                                        <span style="color: #ffa70d;font-size: 14px;">/人起</span>
                                        <span class="pricePerNight cruise-only-title">平均每晚￥{{getPricePerNight(selectedCruise.cruise)}}/人起</span>
                                    </div>
                                    <div class="item-btn moreCruiseBtn">立即预订</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const CruiseTag = () => import('@/components/Cruise/CruiseTag.vue')

import api from '@/api'
import _ from 'lodash'
import nrpConfig from '@/utilities/nrpConfig'
export default {
    name: "MoreSailDatePopup",
    components: {
        CruiseTag
    },
    props: {
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        cruise: {
            type: Object,
            default () {
                return {
                    cruiseName: '',
                    sailDate: '',
                    shipCode: '',
                    isRow: false
                }
            }
        },
        moreSailDatePopupClose: {
            type: Function
        },
        rowCruiseSearchHandler: {
            type: Function
        },
        showLoginPopup: {
            type: Function
        }
    },
    data () {
        return {
            isShowModal: false,
            cruiseLists: [],
            selectedMonth: '',
            selectedCruise: {}
        }
    },
    beforeMount() {
        this.getMoreSailDates()
    },
    methods: {
        async getMoreSailDates() {
            if (!this.cruise || !this.cruise.cruiseName || this.cruise.cruiseName.length == 0) {
                return
            }
            this.$loading.show()
            console.log('getMoreSailDates', this.$route)
            let currentPagePath = this.$route.path
            const { success, data, errMsg } = await api.cruise.getCruiseByRoute(this.cruise.cruiseName,currentPagePath && currentPagePath.includes('SearchRow') ? true : false)
            this.$loading.hide()
            if (!success) {
                console.error(errMsg)
            }
            let shipEvent = []
            for (var i = 0; i < data.length; i++) {
                var date = data[i].sailDate;
                var newDate = new Date(date);
                var year = newDate.getFullYear();
                var month = newDate.getMonth() + 1 < 10 ? "0" + (newDate.getMonth() + 1) : newDate.getMonth() + 1;
                var day = newDate.getDate() < 10 ? "0" + newDate.getDate() : newDate.getDate();
                data[i].sailDate = year + "-" + month + "-" + day;

                shipEvent.push({});
                shipEvent[i].price = data[i].netAmount;
                shipEvent[i].packagePrice = data[i].packagePrice;
                shipEvent[i].date = year + "-" + month + "-" + day;
                shipEvent[i].shipCode = data[i].shipCode;
                shipEvent[i].isNrpPrice = data[i].isNrpPrice;
                shipEvent[i].isRow = data[i].isRow;
                shipEvent[i].cruise = data[i]
            }
            this.cruiseLists = shipEvent
            if (this.cruise.sailDate && this.cruise.sailDate.length > 7) {
                this.selectedMonth = this.cruise.sailDate.substring(0, 7)
            }
            const cruise = this.cruiseLists
                .find(r=>r.date == this.cruise.sailDate && r.shipCode == this.cruise.shipCode)
            if (cruise) {
                this.selectedCruise = cruise
            }

        },
        onMoreSailDateClose () {
            this.isShowModal = false
            setTimeout(()=> {
                this.moreSailDatePopupClose()
            }, 100)
        },
        onMonthClick (date) {
            this.selectedMonth = date
        },
        goNextMonth () {
            let index = this.totalMonth.indexOf(this.selectedMonth)
            if (index < this.totalMonth.length - 1) {
                this.selectedMonth = this.totalMonth[index+1]
                this.changeTitleScroll(index+1)
            }
        },
        goPreMonth () {
            let index = this.totalMonth.indexOf(this.selectedMonth)
            if (index > 0) {
                this.selectedMonth = this.totalMonth[index-1]
                this.changeTitleScroll(index-1)
            }
        },
        changeTitleScroll (index) {
            var width = 92;
            this.$refs.titleContent.scrollLeft = (index-1) * width
        },
        getMonthTitle(month) {
            const date = new Date(month + '-01')
            const today = new Date()
            if (today.getFullYear() == date.getFullYear()) {
                return (date.getMonth() + 1) + "月"
            }
            const title = date.getFullYear() + "年" + (date.getMonth() + 1) + "月"
            return title
        },
        getMonth(index) {
            if (!this.initDateTime) return null
            let date = new Date(this.initDateTime.getTime());
            date = new Date(date.setMonth(date.getMonth() + index))
            return date
        },
        getMonthCalendar () {
            // 根据select month，组装日历数据
            // 日历数组按照周来排列数组，每周又是一个数组，放一周7天的日期
            let calendar = []
            let beginDate = new Date(this.selectedMonth + '-01')
            let nextMonth = new Date(this.selectedMonth + '-01')
            nextMonth = new Date(nextMonth.setMonth(nextMonth.getMonth() + 1))
            let index = 0
            while(beginDate.getTime() < nextMonth.getTime() || index <= 5) {
                let week = []
                for (let i = 0; i < 7; i++) {
                    let day = i
                    if (day == 0) day = 7
                    if ((index == 0 && beginDate.getDay() > (i)) || beginDate.getTime() >= nextMonth.getTime()) {
                        week.push({
                            code: '',
                            name: 0,
                            isNrpPrice: false,
                            day: day,
                            price: '',
                            shipCode: ''
                        })
                    } else {
                        const date = `${beginDate.getFullYear()}-${this.pad(beginDate.getMonth() + 1)}-${this.pad(beginDate.getDate())}`
                        let price = ''
                        let isNrpPrice = false
                        let shipCode = ''
                        let cruises = this.cruiseLists.filter(r=>r.date == date)
                        if (cruises.length > 0) {
                            cruises = _.orderBy(cruises, 'price')
                            price = cruises[0].price.toFixed('0')
                            isNrpPrice = cruises[0].isNrpPrice
                            shipCode = cruises[0].shipCode
                        }

                        week.push({
                            code: date,
                            name: beginDate.getDate(),
                            price: price,
                            isNrpPrice: isNrpPrice,
                            day: day,
                            shipCode: shipCode
                        })
                        beginDate = new Date(beginDate.setDate(beginDate.getDate()+ 1))
                    }
                }
                calendar.push(week)
                index++
            }
            return calendar
        },
        onCalendarItemClick (day) {
            if (!day || !day.shipCode || !day.code) return
            const cruise = this.cruiseLists.find(r=>r.date == day.code && r.shipCode == day.shipCode)
            if (!cruise) return
            this.selectedCruise = cruise
        },
        isTitleActive(month) {
            return month == this.selectedMonth
        },
        hasCalendarEvent (date) {
            return this.cruiseLists.some(r=>r.date == date)
        },
        pad (num) {
            return num < 10 ? "0" + num : num;
        },
        getNrpTitle(isNrp) {
            return isNrp ? nrpConfig.nrp.priceType: nrpConfig.rp.priceType
        },
        getPricePerNight (cruise) {
            return (cruise.netAmount / (cruise.sailDays - 1)).toFixed(0)
        },
        onWishListClick (cruise) {
            if (cruise.inWish) {
                this.deleteWishList(cruise)
            } else {
                this.addWishList(cruise)
            }
        },
        async addWishList (cruise) {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                let self = this
                this.$confirm.show('您尚未登录， 请登录之后， 再添加至心愿单', {
                    confirmCallBack: () => {
                        if (self.showLoginPopup) {
                            self.showLoginPopup(()=> {
                                self.addWishList(cruise)
                            })
                        }
                    }
                })
                return
            }
            const requestData = {
                userName: userToken,
                cruiseId: cruise.cruiseId,
                source: 'pc'
            }
            this.$loading.show()
            const { success } = await api.cruise.addWishList(requestData)
            if (success) {
                cruise.inWish = true
                cruise.collections++
                const cruiseItem = this.cruiseLists.find(r=>r.cruise && r.cruise.cruiseId == cruise.cruiseId)
                if (cruiseItem) {
                    cruiseItem.inWish = true
                    cruiseItem.collections++
                }
                this.$emit('onCruiseAddWishList', cruise.cruiseId)
            }
            this.$loading.hide()
        },
        async deleteWishList (cruise) {
            const userToken = this.$store.state.user.userToken
            if (!userToken || userToken.length == 0) {
                let self = this
                this.$confirm.show('您尚未登录， 请登录之后， 再添加至心愿单', {
                    confirmCallBack: () => {
                        if (self.showLoginPopup) {
                            self.showLoginPopup(()=> {
                                self.deleteWishList(cruise)
                            })
                        }
                    }
                })
                return
            }
            const requestData = {
                userName: userToken,
                cruiseId: cruise.cruiseId,
                source: 'pc'
            }
            this.$loading.show()
            const { success } = await api.cruise.deleteWishList(requestData)
            if (success) {
                cruise.inWish = false
                if (cruise.collections > 0) {
                    cruise.collections--
                }
                const cruiseItem = this.cruiseLists.find(r=>r.cruise && r.cruise.cruiseId == cruise.cruiseId)
                if (cruiseItem) {
                    cruiseItem.inWish = false
                    if (cruiseItem.collections > 0) {
                        cruiseItem.collections--
                    }
                }
                this.$emit('onCruiseDeleteWishList', cruise.cruiseId)
            }
            this.$loading.hide()
        },
        goToCruiseDetail (cruise) {
            location.href = `/Rccl.Cruise/CruiseDetail?shipCode=${cruise.shipCode}&sailDate=${cruise.sailDate}`

        },
    },
    computed: {
        initDate() {
            if (this.cruiseLists.length > 0) {
                const cruises = _.orderBy(this.cruiseLists, 'date')
                return cruises[0].date.substring(0, 7)
            }
            return ""
        },
        initDateTime() {
            if (this.cruiseLists.length > 0) {
                return new Date(this.cruiseLists[0].date)
            }
            return null
        },
        endDate() {
            if (this.cruiseLists.length > 0) {
                const cruises = _.orderBy(this.cruiseLists, 'date')
                return cruises[cruises.length - 1].date.substring(0, 7)
            }
            return ""
        },
        endDateTime() {
            if (this.cruiseLists.length > 0) {
                return new Date(this.cruiseLists[this.cruiseLists.length - 1].date)
            }
            return null
        },
        totalMonth() {
            let months = []
            this.cruiseLists.forEach((cruise) => {
                const date = cruise.date.substring(0, 7)
                if (!months.some(r=>r==date)) {
                    months.push(date)
                }
            })
            months = _.orderBy(months)
            return months
        },

    },
    watch: {
        cruise (newValue) {
            if (newValue && newValue.cruiseName && newValue.cruiseName.length > 0) {
                this.getMoreSailDates()
            }

        },
        isShow (newValue) {
            setTimeout(()=> {
                this.isShowModal = newValue
            }, 100)
        },
    }
}
</script>

<style lang="less">
#moreSailDatePopup.active {
    display: block;
}

#moreSailDatePopup {
    overflow: auto;
    .modal-bg {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
    }
    .modal-body {
        padding: 0px;
    }
    .list-more-date-con {
        // overflow: hidden;
        background-color: #f3f6f8;
        .list-more-date-left-con {
            display: inline-block;
            width: 550px;
            background-color: #fff;
            .calendar {
                position: relative;
                width: 100%;
                padding: 20px 10px 10px 10px;
                background-color: #fff;
                border-radius: 3px;
                border: none;
                margin-top: 0px;
                .calendar__title {
                    text-align: center;
                    width: 100%;
                    border-bottom: 1px solid #d3dadd;
                    position: relative;
                    .calendar__title_content {
                        position: relative;
                        width: 500px;
                        overflow: hidden;
                        margin: 0 auto;
                        .calendar__title_wrapper {
                            width: max-content;
                            .title {
                                position: relative;
                                display: inline-block;
                                vertical-align: middle;
                                font-size: 14px;
                                color: #929c9e;
                                width: 56px;
                                margin: 0 20px;
                                height: 30px;
                                cursor: pointer;
                            }
                            .title.active {
                                color: #000;
                            }
                            .title.active::after {
                                content: '';
                                width: 140%;
                                height: 4px;
                                background: #006ab9;
                                position: absolute;
                                bottom: 0;
                                left: -20%;
                            }
                        }
                    }
                    .sail-date-arrow {
                        position: absolute;
                        top: 3px;
                        display: block;
                        width: 16px;
                        height: 16px;
                        color: #97a1a5;
                        cursor: pointer;
                        &:hover {
                            color: #006ab9;
                        }
                        &::before {
                            content: "";
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            display: block;
                            width: 9px;
                            height: 9px;
                            border: solid currentColor;
                            border-width: 0 2px 2px 0;
                        }
                    }
                    .sail-date-arrow-left {
                        left: 10px;
                        &::before {
                            transform: translate(-35%, -50%) rotate(135deg);
                        }
                    }
                    .sail-date-arrow-right {
                        right: 10px;
                        &::before {
                            transform: translate(-65%, -50%) rotate(-45deg);
                        }
                    }
                }

                .calendar--header {
                    width: 100%;
                    .calendar--header__weekday {
                        display: inline-block;
                        vertical-align: middle;
                        width: 74px;
                        margin-top: 10px;
                        font-size: 14px;
                        font-weight: 700;
                        color: #5a5a5a;
                        height: 40px;
                        line-height: 40px;
                        text-align: center;
                    }
                }
                .calendar--body {
                    position: relative;
                    width: 100%;
                    height: 330px;
                    .calendar--body__line {
                        .vacation {
                            color: #eeeeee;
                        }
                        .line {
                            display: inline-block;
                            float: left;
                            vertical-align: middle;
                            position: relative;
                            text-align: center;
                            width: 74px;
                            height: 86px;
                            margin-top: 0px;
                            background: #f2f6f9;
                            border: 3px solid #fff;
                            border-radius: 10px;
                            border-collapse: inherit;
                            overflow: hidden;
                            cursor: pointer;
                            div {
                                position: relative;
                                top: -3px;
                                width: 36px;
                                height: 24px;
                            }
                            .dateCell {
                                left: 2px;
                                margin-top: 5px;
                            }
                            span {
                                position: absolute;
                                color: #929c9e;
                                font-size: 14px;
                                top: 2px;
                                right: 2px;
                            }
                            .date {
                                padding: 10px 0px;
                            }
                            .priceCell {
                                color: #282B33;
                                font-size: 12px;
                                width: 100%;
                                > div {
                                    line-height: 13px;
                                }
                                .small-font {
                                    font-size: 10px;
                                    color: #282B33;
                                    left: 0;
                                }
                                .price {
                                    font-size: 12px;
                                    color: #282B33;
                                    left: 22px;
                                }
                            }
                            .priceCellHp {
                                bottom: 6px;
                                top: 10px;
                            }
                        }
                        .line.active {
                            background: #007bc4;
                            span {
                                color: white;
                            }
                            .priceCell {
                                .price {
                                    color: white;
                                    position: absolute;
                                    left: 22px;
                                }
                                .small-font {
                                    color: white;
                                    position: absolute;
                                    left: 0px;
                                }
                            }
                        }
                        .line.shipEvent {
                            cursor: pointer;
                        }
                    }
                }
            }
        }
        .list-more-date-right-con {
            width: 364px;
            background-color: #f3f6f8;
            padding: 35px 0px 0px;
            position: relative;
            display: inline-block;
            vertical-align: top;
            .list-item-con {
                margin-left: 18px;
                width: 640px;
                float: left;
                .item-title-con {
                    font-size: 22px;
                    line-height: 30px;
                    color: #282b2c;
                    overflow: hidden;
                    .item-title {
                        max-width: 605px;
                        margin-top: 5px;
                        font-weight: 600;
                    }
                    .like-con {
                        position: absolute;
                        top: 32px;
                        right: 6px;
                        font-size: 12px;
                        color: #747d80;
                        float: right;
                        text-align: center;
                        cursor: pointer;
                        .moreLikeDef {
                            display: inline;
                            position: relative;
                            top: 3px;
                        }
                        .moreLike {
                            display: none;
                        }
                    }
                    .like-con.active {
                        .moreLike {
                            display: inline;
                        }
                        .moreLikeDef {
                            display: none;
                        }
                    }
                }
                .item-tag-con {
                    margin-top: 6px;
                    margin-bottom: 11px;
                    overflow: hidden;
                    .item-tag-item {
                        margin-right: 20px;
                        float: left;
                        line-height: 21px;
                    }
                }
                .item-info-text {
                    font-size: 14px;
                    color: #282b2c;
                    margin-top: 6px;
                    overflow: hidden;
                }
                .list-search-input-tag-con {
                    margin-top: 3px;
                }
                .item-btn-con {
                    position: relative;
                    margin-top: 50px;
                    right: 0;
                    bottom: 10px;
                    min-width: 300px;
                    float: none;
                    .item-price {
                        position: static;
                        margin-bottom: 8px;
                        font-size: 16px;
                        color: #282b2c;
                        cursor: pointer;
                        top: -29px;
                        right: 0;
                        .cruise-only-title {
                            display: block;
                            font-size: 13px;
                            font-weight: 400;
                        }
                    }
                    .item-btn {
                        width: 340px;
                        height: 46px;
                        line-height: 46px;
                        background-color: #fbc500;
                        font-size: 22px;
                        color: #282b2c;
                        text-align: center;
                        font-weight: 500;
                        cursor: pointer;
                        margin-left: 0px;
                    }
                }
            }
        }
    }
}


</style>
